/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState, useContext } from 'react';
import { useSnackbar } from 'notistack';
import DatahubAPI from '../../api/DatahubAPI';
import CircularProgress from '@mui/material/CircularProgress';
import BiteListUpper from 'components/BiteList/BiteListUpper';
import BiteListForm from 'components/BiteList/BiteListForm';
import BiteListHitBreakdown from 'components/BiteList/BiteListHitBreakdown';
import EntityResolution from '../../components/Common/EntityResolution';
import { exportToCSV } from 'components/Common/CSVManage';
import Modal from 'react-modal';
import { Close } from '@mui/icons-material';
import { Typography } from '@mui/material';
import {
  NextButton,
  StyledInput,
} from '../../components/Common/MUIStyledComponents';
import { Redirect } from 'react-router-dom';
import { GlobalContext } from 'providers/GlobalProvider';
import ModuleHeaderLayout from 'components/Common/Layouts/ModuleHeaderLayout';
import { ModuleContentTooltip } from '../../components/Common/MUIStyledComponents';
import RequiredLicense from 'pages/assign/RequiredLicense';
import { LicenseType } from 'pages/assign/LicenseBadge';

const BiteListReact: React.FC = () => {
  // PAYMENTS STATE AND FUNCTIONS
  const { cur_user } = useContext(GlobalContext);
  const requiredTiers = ['pro', 'business', 'enterprise'];
  const [userHasBiteList, setUserHasBiteList] = useState(
    cur_user?.bite_super_admin === true ||
      requiredTiers.includes(cur_user.license),
  );
  const isInteractionDisabled = !userHasBiteList;
  const normalizedLicense = (
    ['none', 'standard', 'pro', 'business', 'enterprise'].includes(
      cur_user?.license,
    )
      ? cur_user.license
      : 'none'
  ) as LicenseType;
  if (!cur_user.selected_team) {
    return <Redirect to='/' />;
  }

  useEffect(() => {
    setUserHasBiteList(
      cur_user?.bite_super_admin === true ||
        requiredTiers.includes(cur_user.license),
    );
  }, [cur_user.license]);

  const [countryData, setCountryData] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: [] });
  const [tableData, setTableData] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: {} });
  const [biteListPrimaryOpts, setBiteListPrimaryOpts] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: {} });
  const [invDomainOpts, setInvDomainOpts] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: {} });
  const [govtAgencyOpts, setGovtAgencyOpts] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: {} });
  const [countryOpts, setCountryOpts] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: {} });
  const [listNameOpts, setListNameOpts] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: {} });
  const [stateOpts, setStateOpts] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: {} });
  const [pepCountryOpts, setPepCountryOpts] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: {} });
  const [entityTypeOpts, setEntityTypeOpts] = useState<{
    isLoading: boolean;
    data: any;
  }>({ isLoading: true, data: {} });
  const [pageNum, setPageNum] = useState<number>(0);

  const [entityToggle, setEntityToggle] = useState(false);

  const [fileName, setFileName] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const [fileNameModalOpen, setFileNameModalOpen] = useState(false);

  // FORM VALUES
  const [formValues, setFormValues] = useState({
    searchValue: '',
    country: [],
    invDomain: [],
    listName: [],
    entityCountry: [],
    entityType: [],
    govtAgency: [],
    state: [],
    fuzziness: 0,
  });

  const [selectedIndex, setSelectedIndex] = useState<string>('Risk Insights');

  const handleIndexChange = (index: string) => {
    if (isInteractionDisabled) {
      return;
    }
    switch (index) {
      case 'Risk Insights':
        setSelectedIndex('Risk Insights');
        break;
      case 'PEP':
        setSelectedIndex('PEP');
        break;
      case 'Debarred':
        setSelectedIndex('Debarred');
        break;
      case 'FF Labor':
        setSelectedIndex('FF Labor');
        break;
      case 'ESG Registrations':
        setSelectedIndex('ESG Registrations');
        break;
      default:
        setSelectedIndex('Risk Insights');
    }
  };

  // file modal
  const handleFileNameChange = (e: any) => {
    setFileName(e.target.value);
  };

  const handleFileNameClose = () => {
    setFileNameModalOpen(false);
    setFileName('');
  };

  const toggleModal = () => {
    if (isInteractionDisabled) {
      return;
    }
    setFileNameModalOpen(true);
  };

  const handleScroll = () => {
    document
      .getElementById('scroll-id')
      ?.scrollIntoView({ behavior: 'smooth' });
  };

  const biteListHeaders = [
    'High Risk Entity',
    'Entity Country',
    'Date Added',
    'Trade Domain',
    'Additional Remarks',
    'Investigative Notes',
  ];
  const pepHeaders = [
    'Name of Entity',
    'Entity Type',
    'Reference Number',
    'Source Information URL',
  ];
  const debarredHeaders = [
    'Name of Entity',
    'List Name',
    'Reference Number',
    'Entity Country',
    'State / Province',
    'Additional Remarks',
  ];
  const ffLaborHeaders = [
    'Name of Entity',
    'List Name',
    'Entity Country',
    'Additional Remarks',
  ];

  const handleCSV = () => {
    if (isInteractionDisabled) {
      return;
    }
    if (selectedIndex === 'Risk Insights') {
      if (tableData.data.hits.hits.length >= 1) {
        exportToCSV(
          fileName,
          [...tableData.data.hits.hits],
          biteListHeaders,
          'biteList',
        );
      } else {
        enqueueSnackbar('No Result Data to Export', { variant: 'error' });
      }
    }
    if (selectedIndex === 'PEP') {
      if (tableData.data.hits.hits.length >= 1) {
        exportToCSV(fileName, [...tableData.data.hits.hits], pepHeaders, 'pep');
      } else {
        enqueueSnackbar('No Result Data to Export', { variant: 'error' });
      }
    }
    if (selectedIndex === 'Debarred') {
      if (tableData.data.hits.hits.length >= 1) {
        exportToCSV(
          fileName,
          [...tableData.data.hits.hits],
          debarredHeaders,
          'debarred',
        );
      } else {
        enqueueSnackbar('No Result Data to Export', { variant: 'error' });
      }
    }
    if (selectedIndex === 'FF Labor' || selectedIndex === 'ESG Registrations') {
      if (tableData.data.hits.hits.length >= 1) {
        exportToCSV(
          fileName,
          [...tableData.data.hits.hits],
          ffLaborHeaders,
          'ffLabor',
        );
      } else {
        enqueueSnackbar('No Result Data to Export', { variant: 'error' });
      }
    }
  };

  const getInitialResults = async () => {
    if (isInteractionDisabled) {
      setTableData({ isLoading: false, data: { hits: { hits: [], total: { value: 0 } } } });
      setCountryData({ isLoading: false, data: {} });
      return;
    }
    setTableData({ isLoading: true, data: {} });
    setCountryData({ isLoading: true, data: {} });
    const res = await DatahubAPI.biteList({
      indexName: selectedIndex,
      agg: true,
      pageNum: 0,
    });
    if (res?.success) {
      setCountryData({
        isLoading: false,
        data: res?.result?.result?.body?.aggregations,
      });
      setTableData({ isLoading: false, data: res?.result?.result?.body });
      setBiteListPrimaryOpts({
        isLoading: false,
        data: res?.result?.result?.body?.aggregations,
      });
    }
  };

  const queryBiteList = async (values: any, page: number) => {
    if (isInteractionDisabled) {
      setTableData({ isLoading: false, data: { hits: { hits: [], total: { value: 0 } } } });
      setCountryData({ isLoading: false, data: {} });
      return;
    }
    let fuzzyValue = '';
    if (entityToggle) {
      fuzzyValue = 'AUTO';
    } else {
      fuzzyValue = '0';
    }
    const res = await DatahubAPI.biteList({
      indexName: selectedIndex,
      agg: true,
      primary: values.searchValue,
      listCountry: values.country,
      invDomain: values.invDomain,
      listName: values.listName,
      govtAgency: values.govtAgency,
      state: values.state,
      fuzziness: fuzzyValue,
      pageNum: page,
    });
    if (res?.success) {
      setTableData({ isLoading: false, data: res?.result?.result?.body });
      setCountryData({
        isLoading: false,
        data: res?.result?.result?.body?.aggregations,
      });
    } else {
      enqueueSnackbar(
        'Error retrieving data. High Risk Entities may be being updated',
        { variant: 'error', autoHideDuration: 5000 },
      );
    }
  };

  useEffect(() => {
    if (isInteractionDisabled) {
      return;
    }
    setFormValues({
      searchValue: '',
      country: [],
      invDomain: [],
      listName: [],
      entityCountry: [],
      entityType: [],
      govtAgency: [],
      state: [],
      fuzziness: 0,
    });
    getInitialResults();
  }, [selectedIndex, isInteractionDisabled]);

  // dynamic table data filtering on dropdown option select/deselect
  useEffect(() => {
    if (isInteractionDisabled) {
      return;
    }
    queryBiteList(formValues, pageNum);
  }, [
    formValues.country,
    formValues.invDomain,
    formValues.listName,
    formValues.entityType,
    formValues.govtAgency,
    formValues.state,
    isInteractionDisabled,
  ]);

  const helpContent = (
    <p className='module-header-tooltip-text'>
      The High Risk Entities List is a list of flagged entities and commodities
      compiled by the BITE team. Please select which list you would like to
      search in the top tabs. Use the search bar to look up specific queries.
    </p>
  );

  return (
    <ModuleHeaderLayout
      title='High Risk Entities'
      helpContent={helpContent}
      hubLabel='Data Catalog'
      hubTo='/data/sets'
    >
      <div className='os-iframe'>
        <RequiredLicense userLicense={normalizedLicense} minimumLicense='pro' />
        <div className='bl-index-select'>
          <div
            className='bl-index-item'
            onClick={() => {
              if (!isInteractionDisabled) {
                handleIndexChange('Risk Insights');
              }
            }}
            style={{ cursor: isInteractionDisabled ? 'not-allowed' : 'pointer' }}
          >
            <ModuleContentTooltip
              placement='top'
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    display: 'flex',
                    padding: 'var(--spacing-md, 8px) var(--spacing-lg, 12px)',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    alignSelf: 'stretch',
                    borderRadius: 'var(--radius-md, 8px)',
                    background: 'var(--Background-200, var(--bg-colors))',
                    color: 'var(--text-prim25)',
                    maxWidth: '400px',
                    '& .MuiTooltip-arrow': {
                      color: 'var(--Background-200, var(--bg-colors))',
                    },
                  },
                },
              }}
              title={
                <p className='module-header-tooltip-text'>
                  Use the search bar to look up specific queries (entities or
                  addresses). Use Advanced Filters to select specific Listing
                  Countries and List Names.
                </p>
              }
            >
              <div className='bl-item-title'>Risk Insights</div>
            </ModuleContentTooltip>
            <div className='bl-item-svg'>
              {selectedIndex === 'Risk Insights' ? (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='206'
                  height='4'
                  viewBox='0 0 206 4'
                  fill='none'
                >
                  <path
                    d='M2 2L204.333 1.99998'
                    stroke='url(#paint0_linear_2173_3230)'
                    strokeWidth='3'
                    strokeLinecap='round'
                  />
                  <defs>
                    <linearGradient
                      id='paint0_linear_2173_3230'
                      x1='2'
                      y1='2'
                      x2='204.333'
                      y2='1.99977'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stopColor='#4CC9F0' />
                      <stop offset='0.453125' stopColor='#4895EF' />
                      <stop offset='1' stopColor='#4361EE' />
                    </linearGradient>
                  </defs>
                </svg>
              ) : (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='207'
                  height='4'
                  viewBox='0 0 207 4'
                  fill='none'
                >
                  <path
                    d='M2.33337 2L204.667 2.00002'
                    stroke='#4A4C51'
                    strokeWidth='3'
                    strokeLinecap='round'
                  />
                </svg>
              )}
            </div>
          </div>
          <div
            className='bl-index-item'
            onClick={() => {
              if (!isInteractionDisabled) {
                handleIndexChange('PEP');
              }
            }}
            style={{ cursor: isInteractionDisabled ? 'not-allowed' : 'pointer' }}
          >
            <ModuleContentTooltip
              placement='top'
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    'display': 'flex',
                    'padding': 'var(--spacing-md, 8px) var(--spacing-lg, 12px)',
                    'flexDirection': 'column',
                    'alignItems': 'flex-start',
                    'alignSelf': 'stretch',
                    'borderRadius': 'var(--radius-md, 8px)',
                    'background': 'var(--Background-200, var(--bg-colors))',
                    'color': 'var(--text-prim25)',
                    'maxWidth': '400px',
                    '& .MuiTooltip-arrow': {
                    color: 'var(--Background-200, var(--bg-colors))',
                    },
                  },
                },
              }}
              title={
                <p className='module-header-tooltip-text'>
                  Use the search bar to look up specific queries (entities or
                  addresses). Use Advanced Filters to select specific Listing
                  Countries and List Names.
                </p>
              }
            >
              <div className='bl-item-title'>PEPs & Beneficial Ownership</div>
            </ModuleContentTooltip>
            <div className='bl-item-svg'>
              {selectedIndex === 'PEP' ? (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='206'
                  height='4'
                  viewBox='0 0 206 4'
                  fill='none'
                >
                  <path
                    d='M2 2L204.333 1.99998'
                    stroke='url(#paint0_linear_2173_3230)'
                    strokeWidth='3'
                    strokeLinecap='round'
                  />
                  <defs>
                    <linearGradient
                      id='paint0_linear_2173_3230'
                      x1='2'
                      y1='2'
                      x2='204.333'
                      y2='1.99977'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stopColor='#4CC9F0' />
                      <stop offset='0.453125' stopColor='#4895EF' />
                      <stop offset='1' stopColor='#4361EE' />
                    </linearGradient>
                  </defs>
                </svg>
              ) : (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='207'
                  height='4'
                  viewBox='0 0 207 4'
                  fill='none'
                >
                  <path
                    d='M2.33337 2L204.667 2.00002'
                    stroke='#4A4C51'
                    strokeWidth='3'
                    strokeLinecap='round'
                  />
                </svg>
              )}
            </div>
          </div>
          <div
            className='bl-index-item'
            onClick={() => {
              if (!isInteractionDisabled) {
                handleIndexChange('Debarred');
              }
            }}
            style={{ cursor: isInteractionDisabled ? 'not-allowed' : 'pointer' }}
          >
            <ModuleContentTooltip
              placement='top'
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    display: 'flex',
                    padding: 'var(--spacing-md, 8px) var(--spacing-lg, 12px)',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    alignSelf: 'stretch',
                    borderRadius: 'var(--radius-md, 8px)',
                    background: 'var(--Background-200, var(--bg-colors))',
                    color: 'var(--text-prim25)',
                    maxWidth: '400px',
                    '& .MuiTooltip-arrow': {
                      color: 'var(--Background-200, var(--bg-colors))',
                    },
                  },
                },
              }}
              title={
                <p className='module-header-tooltip-text'>
                  Includes debarred entities that the US Government has
                  identified as not eligible to do business with the Federal
                  Government, and other lists of entities with derogatory marks.
                  Use the search bar to look up specific queries (entities or
                  addresses). Use Advanced Filters to select specific Listing
                  Countries and List Names.
                </p>
              }
            >
              <div className='bl-item-title'>Debarred Entities</div>
            </ModuleContentTooltip>
            <div className='bl-item-svg'>
              {selectedIndex === 'Debarred' ? (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='206'
                  height='4'
                  viewBox='0 0 206 4'
                  fill='none'
                >
                  <path
                    d='M2 2L204.333 1.99998'
                    stroke='url(#paint0_linear_2173_3230)'
                    strokeWidth='3'
                    strokeLinecap='round'
                  />
                  <defs>
                    <linearGradient
                      id='paint0_linear_2173_3230'
                      x1='2'
                      y1='2'
                      x2='204.333'
                      y2='1.99977'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stopColor='#4CC9F0' />
                      <stop offset='0.453125' stopColor='#4895EF' />
                      <stop offset='1' stopColor='#4361EE' />
                    </linearGradient>
                  </defs>
                </svg>
              ) : (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='207'
                  height='4'
                  viewBox='0 0 207 4'
                  fill='none'
                >
                  <path
                    d='M2.33337 2L204.667 2.00002'
                    stroke='#4A4C51'
                    strokeWidth='3'
                    strokeLinecap='round'
                  />
                </svg>
              )}
            </div>
          </div>

          <div
            className='bl-index-item'
            onClick={() => {
              if (!isInteractionDisabled) {
                handleIndexChange('FF Labor');
              }
            }}
            style={{ cursor: isInteractionDisabled ? 'not-allowed' : 'pointer' }}
          >
            <ModuleContentTooltip
              placement='top'
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    display: 'flex',
                    padding: 'var(--spacing-md, 8px) var(--spacing-lg, 12px)',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    alignSelf: 'stretch',
                    borderRadius: 'var(--radius-md, 8px)',
                    background: 'var(--Background-200, var(--bg-colors))',
                    color: 'var(--text-prim25)',
                    maxWidth: '400px',
                    '& .MuiTooltip-arrow': {
                      color: 'var(--Background-200, var(--bg-colors))',
                    },
                  },
                },
              }}
              title={
                <p className='module-header-tooltip-text'>
                  Includes lists of entities associated with various ESG
                  indicators. Use the search bar to look up specific queries
                  (entities or addresses). Use Advanced Filters to select
                  specific Listing Countries and List Names.
                </p>
              }
            >
              <div className='bl-item-title'>ESG & Forced Labor</div>
            </ModuleContentTooltip>
            <div className='bl-item-svg'>
              {selectedIndex === 'FF Labor' ||
              selectedIndex === 'ESG Registrations' ? (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='206'
                  height='4'
                  viewBox='0 0 206 4'
                  fill='none'
                >
                  <path
                    d='M2 2L204.333 1.99998'
                    stroke='url(#paint0_linear_2173_3230)'
                    strokeWidth='3'
                    strokeLinecap='round'
                  />
                  <defs>
                    <linearGradient
                      id='paint0_linear_2173_3230'
                      x1='2'
                      y1='2'
                      x2='204.333'
                      y2='1.99977'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stopColor='#4CC9F0' />
                      <stop offset='0.453125' stopColor='#4895EF' />
                      <stop offset='1' stopColor='#4361EE' />
                    </linearGradient>
                  </defs>
                </svg>
              ) : (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='207'
                  height='4'
                  viewBox='0 0 207 4'
                  fill='none'
                >
                  <path
                    d='M2.33337 2L204.667 2.00002'
                    stroke='#4A4C51'
                    strokeWidth='3'
                    strokeLinecap='round'
                  />
                </svg>
              )}
            </div>
          </div>
        </div>
        {selectedIndex === 'FF Labor' && (
          <div className='embargoed-options-container'>
            <div className='select-one-text'>Select One</div>
            <div className='embargoed-country-select-container'>
              <div
                className='country-button-option-selected'
                onClick={() => {
                  if (!isInteractionDisabled) {
                    handleIndexChange('FF Labor');
                  }
                }}
              >
                <div className='country-btn-text'>High Risk</div>
              </div>
              <div
                className='country-button-option'
                onClick={() => {
                  if (!isInteractionDisabled) {
                    handleIndexChange('ESG Registrations');
                  }
                }}
              >
                <div className='country-btn-text'>ESG Registrations</div>
              </div>
            </div>
          </div>
        )}
        {selectedIndex === 'ESG Registrations' && (
          <div className='embargoed-options-container'>
            <div className='select-one-text'>Select One</div>
            <div className='embargoed-country-select-container'>
              <div
                className='country-button-option'
                onClick={() => {
                  if (!isInteractionDisabled) {
                    handleIndexChange('FF Labor');
                  }
                }}
              >
                <div className='country-btn-text'>High Risk</div>
              </div>
              <div
                className='country-button-option-selected'
                onClick={() => {
                  if (!isInteractionDisabled) {
                    handleIndexChange('ESG Registrations');
                  }
                }}
              >
                <div className='country-btn-text'>ESG Registrations</div>
              </div>
            </div>
          </div>
        )}

        <BiteListForm
          queryBiteList={queryBiteList}
          pageNum={pageNum}
          selectedIndex={selectedIndex}
          formValues={formValues}
          setFormValues={setFormValues}
          biteListPrimaryOpts={biteListPrimaryOpts}
          setBiteListPrimaryOpts={setBiteListPrimaryOpts}
          invDomainOpts={invDomainOpts}
          setInvDomainOpts={setInvDomainOpts}
          countryOpts={countryOpts}
          setCountryOpts={setCountryOpts}
          entityTypeOpts={entityTypeOpts}
          govtAgencyOpts={govtAgencyOpts}
          setGovtAgencyOpts={setGovtAgencyOpts}
          listNameOpts={listNameOpts}
          setListNameOpts={setListNameOpts}
          stateOpts={stateOpts}
          setStateOpts={setStateOpts}
          pepCountryOpts={pepCountryOpts}
          setPepCountryOpts={setPepCountryOpts}
          setEntityTypeOpts={setEntityTypeOpts}
          getInitialResults={getInitialResults}
          countryData={countryData}
          isInteractionDisabled={isInteractionDisabled}
        />
        <EntityResolution
          entityToggle={entityToggle}
          setEntityToggle={setEntityToggle}
          isInteractionDisabled={isInteractionDisabled}
        />
        <div className='wl-upper-results'>
          {countryData.isLoading ? (
            <div>
              <CircularProgress style={{ color: '#0E8BFF' }} />
            </div>
          ) : (
            <BiteListUpper
              selectedIndex={selectedIndex}
              countryData={countryData}
              handleScroll={handleScroll}
            />
          )}
        </div>
        {tableData.isLoading ? (
          <div>
            <CircularProgress style={{ color: '#0E8BFF' }} />
          </div>
        ) : (
          <div id='scroll-id'>
            <BiteListHitBreakdown
              toggleModal={toggleModal}
              selectedIndex={selectedIndex}
              queryResults={queryBiteList}
              formValues={formValues}
              pageNum={pageNum}
              setPageNum={setPageNum}
              tableData={tableData}
              isInteractionDisabled={isInteractionDisabled}
            />
          </div>
        )}
        <Modal
          isOpen={fileNameModalOpen}
          onRequestClose={handleFileNameClose}
          ariaHideApp={false}
        >
          <div className='bite-score-file-modal'>
            <div className='display-flex justify-between width-100'>
              <Typography variant='h5'>File Name:</Typography>
              <Close onClick={handleFileNameClose} className='cursor-pointer' />
            </div>
            <div className='display-flex justify-end width-100'>
              <StyledInput
                value={fileName}
                onChange={handleFileNameChange}
                variant='outlined'
                className='margin-right-20px'
              />
              <NextButton
                variant='contained'
                color='primary'
                disabled={isInteractionDisabled}
                onClick={() => {
                  handleCSV();
                  handleFileNameClose();
                }}
              >
                Download
              </NextButton>
            </div>
          </div>
        </Modal>
      </div>
    </ModuleHeaderLayout>
  );
};

export default BiteListReact;
